export default "__VITE_ASSET__BZYUYtvg__"